module.exports = __webpack_public_path__ + "static/img/ket-renewal-mobile-main-02@w.5065f4d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/ket-renewal/ket-renewal-mobile-main-02@w.png
// module id = Ww/L
// module chunks = 0